exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tab{justify-content:left}.updatedAt{font-size:9px;color:red}", ""]);

// exports
